import PropTypes from 'prop-types';
import { Fragment } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import AddonCheckbox from '../AddonCheckbox';

const TicketAddons = ({ addons = [], ticketIndex }) =>
  addons.length > 0 ? (
    <Box mb={3} flexDirection="column" maxWidth={536}>
      <Box mb={5}>
        <strong>{__('Additional Items available')}</strong>
      </Box>
      {addons.map((addon, i) => (
        <Fragment
          key={`attendee-${ticketIndex}-addon-${i}`} // Using index plus object id to assure uniqueness
        >
          <Box flexGrow={1} flexDirection="column">
            <AddonCheckbox
              name={`network_events_booking[attendees_attributes][${ticketIndex}][addons_attributes][${i}]`}
              addon={addon}
            />
          </Box>
          {i + 1 < addons.length && <AddonHr />}
        </Fragment>
      ))}
    </Box>
  ) : null;

TicketAddons.propTypes = {
  addons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      description: PropTypes.string,
      currency: PropTypes.shape({
        code: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        symbol: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ).isRequired,
};

export default TicketAddons;

const AddonHr = styled.hr`
  display: block;
  width: 100%;
  margin: ${({ theme }) => theme.space[3]}px 0;
  border-bottom-style: solid;
  border-color: ${({ theme }) => theme.colors.horizon};
`;
